export default __webpack_public_path__ + "static/media/10.297a09c0.webp";